module.exports = __webpack_public_path__ + "static/media/oakland-800.f4c131e6.png";